import { useContext } from 'react';

import { ParameterDeclarationContext } from 'search-filter/logic/ParameterDeclarationProvider';

const useParameterDeclarationContext = <T>() => useContext<T>(ParameterDeclarationContext);

export default useParameterDeclarationContext;
